import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MAT_DATE_FORMATS, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { QuillModule } from 'ngx-quill';
import { MatBadgeModule } from '@angular/material/badge';
import { TreoCardModule } from 'tsui/@treo';
import moment from 'moment';
import { TreoAutogrowModule } from 'tsui/@treo';
import { TreoFindByKeyPipeModule } from 'tsui/@treo';
import { TreoMessageModule } from 'tsui/@treo';
import { Overlay, OverlayModule } from '@angular/cdk/overlay';
import {
  MAT_LEGACY_AUTOCOMPLETE_SCROLL_STRATEGY as MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
  MatLegacyAutocompleteModule as MatAutocompleteModule,
} from '@angular/material/legacy-autocomplete';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { SharedModule } from 'app/shared/shared.module';

import { contactsRoutes } from './contacts.routing';
import { ContactsComponent } from './contacts.component';
import { ContactsDetailsComponent } from './details/details.component';
import { ContactsListComponent } from './list/list.component';
import { ContactsModalModule } from './modals/modals.module';
import { ContactsImportComponent } from './import/import.component';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { ContactTaskDetailsComponent } from './task/contact-task-details.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatExpansionModule } from '@angular/material/expansion';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TagsPanelComponent } from 'app/shared/components/tags-panel/tags-panel.component';
import { TreoNavigationModule } from 'tsui/@treo';
import { EngagementsModule } from '../engagements/enagements.module';
import { LegacyTaskTableModule } from 'app/shared/modules/legacy-tasks/list/table/table.module';
import { ColumnSelectorModule } from 'app/shared/components/column-selector/column-selector.module';
import { TasksCrmPanelModule } from 'app/shared/modules/legacy-tasks/tasks-crm-panel/tasks-crm-panel.module';
import { SavedViewSidebarComponent } from 'app/shared/components/saved-view-sidebar/saved-view-sidebar.component';
import { PanelsModule } from 'app/shared/components/panels/panels.module';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import {
  TsPageHeaderModule,
  TsPaginatorModule,
  TsBreadcrumbModule,
  TsButtonModule,
  TSIconModule,
  TsBadgeModule,
  TsOverlayModule,
  TsFilterModule,
  TsPageComponent,
  TsInputComponent,
  TsMenuComponent,
} from 'tsui';
import { TsPipesModule } from 'tsui/lib/cross-cutting/pipes/ts-pipes.module';
import { TsTableComponent } from 'tsui/lib/ts-table';
import { TaskDetailsChecklistComponent } from '@tasks/task-details/task-details-checklist/task-details-checklist.component';
import { HasPermissionPipe } from '@shared/pipes/has-permission.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TaskDetailsComponent } from '@tasks/task-details/task-details.component';
import { TaskState } from '@tasks/state/state';
import { NgxsModule } from '@ngxs/store';

const TSUI_MODULES = [
  TsPipesModule,
  TsPageHeaderModule,
  TsPaginatorModule,
  TsBreadcrumbModule,
  TsButtonModule,
  TSIconModule,
  TsBadgeModule,
  TsOverlayModule,
  TsFilterModule,
];

@NgModule({
  declarations: [
    ContactsComponent,
    ContactsListComponent,
    ContactsImportComponent,
    ContactsDetailsComponent,
    ContactTaskDetailsComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(contactsRoutes),
    NgxsModule.forRoot([TaskState]),
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDividerModule,
    MatFormFieldModule,
    MatButtonToggleModule,
    MatIconModule,
    MatBadgeModule,
    TreoCardModule,
    MatInputModule,
    MatMenuModule,
    MatMomentDateModule,
    MatProgressBarModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSortModule,
    MatPaginatorModule,
    MatSidenavModule,
    MatTableModule,
    MatTooltipModule,
    OverlayModule,
    QuillModule,
    ContactsModalModule,
    EngagementsModule,
    TreoAutogrowModule,
    MatAutocompleteModule,
    MatChipsModule,
    TreoFindByKeyPipeModule,
    TreoMessageModule,
    TreoNavigationModule,
    MatProgressSpinnerModule,
    NgxMaterialTimepickerModule,
    DigitOnlyModule,
    SharedModule,
    MatTabsModule,
    MatExpansionModule,
    DragDropModule,
    LegacyTaskTableModule,
    ColumnSelectorModule,
    TasksCrmPanelModule,
    TagsPanelComponent,
    SavedViewSidebarComponent,
    PanelsModule,
    ...TSUI_MODULES,
    TsPageComponent,
    NgxMaskDirective,
    NgxMaskPipe,
    TsInputComponent,
    TsTableComponent,
    TaskDetailsChecklistComponent,
    HasPermissionPipe,
    TaskDetailsComponent,
    TsMenuComponent,
  ],
  providers: [
    provideNgxMask(),
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: moment.ISO_8601,
        },
        display: {
          dateInput: 'LL',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },
    {
      provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
      useFactory: (overlay: Overlay) => {
        return () => overlay.scrollStrategies.block();
      },
      deps: [Overlay],
    },
  ],
})
export class ContactsModule {}
